import { SxProps, Theme } from '@mui/material';

// A chip is never wider than this list, and then its label ends in an
// ellipsis. The list must not set the column's width itself: sized by its
// text, one long tag stretches the column and the whole table. So it reports
// no width of its own (width: 0) and fills whatever the cell has (minWidth).
export type ChipListGaps = { columnGap: string; rowGap: string };

const container = (gaps?: ChipListGaps): SxProps<Theme> => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.5,
  width: 0,
  minWidth: '100%',
  ...gaps
});

const chip: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: 'customGrey.dark',
    color: 'white'
  }
};

const clickableChip: SxProps<Theme> = {
  ...chip,
  cursor: 'pointer'
};

const showMoreLink: SxProps<Theme> = {
  fontSize: 'inherit',
  cursor: 'pointer',
  textDecoration: 'underline',
  mb: 0.5,
  color: 'primary.main',
  alignSelf: 'center',
  '&:hover': {
    textDecoration: 'underline'
  }
};

export const truncatedChipListSx = {
  container,
  chip,
  clickableChip,
  showMoreLink
};
